import five from "../../../src/assets/images/five.png";
import four from "../../../src/assets/images/four.png";
import three from "../../../src/assets/images/three.png";
import two from "../../../src/assets/images/two.png";
import one from "../../../src/assets/images/one.png";

import SentimentBar from "./SentimentBar";
import classes from "./SentimentItem.module.css";
import { trimBeforeInstructions } from "./SentimentTable";

function SentimentItem({ sentiment }) {
  const selectedSentiment = sentiment; //sentiment[activeItemIndex];

  let sentimentIcon = "";
  switch (selectedSentiment?.llm_sentiment) {
    case "Positive":
      sentimentIcon = <img height={30} width={30} src={five} alt="5" />;
      break;
    case "Slightly Positive":
      sentimentIcon = <img height={30} width={30} src={four} alt="4" />;
      break;
    case "Neutral":
      sentimentIcon = <img height={30} width={30} src={three} alt="3" />;
      break;
    case "Slightly Negative":
      sentimentIcon = <img height={30} width={30} src={two} alt="2" />;
      break;
    case "Negative":
      sentimentIcon = <img height={30} width={30} src={one} alt="1" />;
      break;
    default:
      sentimentIcon = "";
  }

  return (
    <div className={classes.container}>
      <div>
        {!selectedSentiment?.confidenceScores && (
          <div className="d-flex flex-column my-3">
            <span className={classes.sentiment_text}>
              {selectedSentiment?.llm_sentiment}
            </span>
            <div className="d-flex align-items-center">
              {sentimentIcon && (
                <span className={classes.sentiment_icon}>{sentimentIcon}</span>
              )}
              <span className={classes.sentiment_score}>
                {selectedSentiment?.sentiment !== undefined ||
                  selectedSentiment?.sentiment != null
                  ? `Sentiment: ${selectedSentiment?.sentiment}`
                  : selectedSentiment?.llm_sentiment_score}
              </span>
            </div>
          </div>
        )}
        {selectedSentiment?.confidenceScores &&
          selectedSentiment?.llm_sentiment && (
            <SentimentBar
              confidenceScores={selectedSentiment?.confidenceScores}
              sentiment={selectedSentiment?.llm_sentiment}
            />
          )}
        {selectedSentiment?.question && (
          <b className="d-block">{trimBeforeInstructions(selectedSentiment?.question)}</b>
        )}
        <p className={classes.response_text}>{selectedSentiment.response}</p>

        {selectedSentiment?.explanation && (
          <div>
            <b>Explanation:</b>
            <br />
            <span className={classes.response_text}>
              {selectedSentiment?.explanation}
            </span>
          </div>
        )}
        <hr />
      </div>
    </div>
  );
}

export default SentimentItem;
